// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Content_wrapper__2KoHl","container":"Content_container__1_biQ"};